// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Hbn5CBJbdx43LEe6XorMb","imageContainer":"_2oJdknaIAFfoIc87SLd6VN","icon":"_2Nw-cHRYaOK8bYvAY5k14h","text":"_1UXfuOt1PWLB9YlnWAzGN4"};